import { Injectable } from '@angular/core';
import {ConfigurationDataProvider} from '../configuration-data-provider';
import {SharedDataProvider} from '../shared-data-provider';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Location} from '../dto/location';

@Injectable()
export class LocationProvider {

  headers = new HttpHeaders({
      'Content-Type': 'application/json'
  });

  constructor(public http: HttpClient, private config : ConfigurationDataProvider, private shared: SharedDataProvider) {
  }

  /**
   * List all locations which belong to loggedin user.
   */
  public list() {
    console.log(JSON.stringify(this.shared.getTokenAuthData()));
    return this.http.post(this.config.locationURL+"list", JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public save(location : Location) {
    console.log('Push location to insert method of service.');
    location.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(location));
    return this.http.post(this.config.locationURL+"new", JSON.stringify(location), {headers: this.headers});
  }

  public update(location : Location) {
    console.log('Push location to update method of service.');
    location.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(location));
    return this.http.put(this.config.locationURL+"id/"+location.id, JSON.stringify(location), {headers: this.headers});
  }

  public qryLocation(id : number) {
    return this.http.post(this.config.locationURL+"id/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public qryBarcode(barcode : string) {
    return this.http.post(this.config.locationURL+"barcode/"+barcode, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public delete(id : number) {
    console.log('Delete location '+ id);
    return this.http.post(this.config.locationURL+"del/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public cntLocations(areaid : number) {
    console.log('Get count of locations in area '+ areaid);
    return this.http.post(this.config.locationURL+"area/"+areaid+"/cnt", 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public listLocationsInArea(areaid : number) {
    console.log('Get list of locations in area '+ areaid);
    return this.http.post(this.config.locationURL+"area/"+areaid+"/list", 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public load(first : number, pageSize: number, sortField : string, sortOrder: string, filterSet : any) {
    let paramSet : any = {};
    paramSet.credentials = this.shared.getTokenAuthData();
    paramSet.first = first;
    paramSet.pageSize = pageSize;
    paramSet.sortField = sortField;
    paramSet.sortOrder = sortOrder;
    paramSet.filters = filterSet;

    console.log("Load locations filtered: "+JSON.stringify(paramSet));

    return this.http.post(this.config.locationURL+"filter", JSON.stringify(paramSet), {headers: this.headers});
  }
}



// WEBPACK FOOTER //
// ./src/providers/location/location.ts